export default "__VITE_ASSET__doYu3KK___"